<template>
  <!--页面加载动画-->
  <div class="select-box">
    <span class="defaultTxt" @click="showLayer=true">
      {{defaultTxt}}
      <i class="iconfont iconzhankai-xianxing"></i>
    </span>
    <van-popup v-model="showLayer">
      <div class="selectContent">
        <van-radio-group v-model="defaultvalue" @change="getResult">
          <template v-for="(item,i) in arrs">
            <van-radio :name="item.value">{{item.name}}</van-radio>
          </template>
        </van-radio-group>
      </div>
    </van-popup>
  </div>
</template>

<script>
import _ from "lodash"; //lodash.js
export default {
  data() {
    return {
      defaultvalue: -1,
      arrs: new Array(), //选择元素
      showLayer: false, //是否弹窗选择框
      defaultTxt: "", //默认值
      title: "" //弹窗顶部标题
    };
  },
  props: ["selectData", "parentItem"],
  mounted() {
    this.arrs = this.selectData.elementItems || [];
    this.checkDefault();
  },
  computed: {
    columns() {
      let data = this.selectData.elementItems;
      return data;
    }
  },
  methods: {
    checkDefault() {
      //检测和设置默认值
      let arr = this.arrs;
      const value = this.selectData.elementValue;
      let index = arr.findIndex(item => {
        return item.value == value;
      });
      if (index > -1) {
        this.defaultvalue = this.arrs[index].value;
      } else {
        this.defaultvalue = -1;
      }
      this.defaultTxt = index > -1 ? this.arrs[index].name : "请选择";
    },
    getResult() {
      this.showLayer = false;
      //选择后回调到父组件
      let value = this.defaultvalue;
      this.selectData.elementValue = value;
      this.$emit("selected", {
        type: 1,
        item: this.selectData,
        value: value
      });
    }
  },
  watch: {
    selectData(newVal) {
      this.arrs = newVal.elementItems;
      this.checkDefault();
    }
  }
};
</script>

<style lang="scss" scoped>
.select-box {
  width: 100%;
  height: 100%;
  .selectContent {
    padding: 30px;
    .van-radio-group {
      max-height: 700px;
      width: 500px;
      overflow: scroll;
      -webkit-overflow-scrolling: touch;
      .van-radio{
        margin-bottom: 8px;
        &:nth-last-of-type(1){
          margin: 0;
        }
      }
    }
  }
  .lz-drop-check {
    text-align: center;
    cursor: pointer;
    min-width: 130px;
    height: 100%;
    font-size: 30px;
    line-height: 54px;
    box-shadow: 0 0 3px 0 rgba(0, 132, 255, 0.5);
    padding: 0 15px;
    color: #666;
    display: inline-block;
    margin: 5px 8px 5px 0;
    background-color: #fff;
    border-radius: 60px;
    &[data-check="true"] {
      color: #fff;
      background-color: #0084ff;
    }
  }
  .drop-2 {
    min-width: 45%;
  }
  .iconfont {
    position: absolute;
    right: 0;
    top: 50%;
    transform: translateY(-50%);
    color: #999;
    font-size: 36px;
  }
}
.defaultTxt {
  width: 100%;
  height: 100%;
  line-height: 40px;
  font-size: 30px;
  padding-top: 10px;
  padding-bottom: 10px;
  padding-right: 50px;
  display: inline-block;
}

.select-layer-box {
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1000;
  .mask {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    background-color: rgba($color: #000000, $alpha: 0.5);
    z-index: 1;
  }
  .mainContent {
    position: absolute;
    width: 10rem;
    left: 50%;
    bottom: 0;
    z-index: 2;
    background-color: #fff;
    transform: translateX(-50%);
  }
  .btn {
    line-height: 80px;
    padding: 0 20px;
  }
  .btn-cancle {
    float: left;
  }
  .btn-sure {
    float: right;
    color: #0084ff;
  }
}
</style>